export default __webpack_public_path__ + "static/media/banner 16-9 Santa-01.286e7d65.png";